// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-6e0cdf50]{width:100px;height:100px;background-color:var(--textcolor);top:calc(50% - 50px);left:calc(50% - 50px);border-radius:100%;transform-origin:center;animation:sk-scaleout-6e0cdf50 1s ease-in-out infinite}@keyframes sk-scaleout-6e0cdf50{0%{transform:scale(0)}to{transform:scale(1);opacity:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
